import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { PatientVaccineSettings,PatientVaccineSettingsData } from '../../../interfaces/masters/patientvaccinesettings';
import { PatientVaccineSettingsApi } from '../api/patientvaccinesettings.api';




@Injectable()
export class PatientVaccineSettingsService extends PatientVaccineSettingsData {

  
  constructor(private api: PatientVaccineSettingsApi) {
    super();
  }
  list(url: string): Observable<PatientVaccineSettings> {
    return this.api.list(url);
  }

 

  create(url: string, data:PatientVaccineSettings): Observable<PatientVaccineSettings> {
    return this.api.create(url,data);
  }
  

}
